var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AgmInfoWindow } from '@agm/core';
import { OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { config } from '../../../../config/config';
import { AddEventBriteGeneralFeedCommand } from '../../../commands/hub/event/add.eventbrite.general.feed.command';
import { HubFacebookFeedsCommand } from '../../../commands/hub/event/add.facebook.general.feed.command';
import { AddFacebookLocationFeedCommand } from '../../../commands/hub/event/add.facebook.location.feed.command';
import { AddressInputComponent } from '../../../common/components/address.input/address.input.component';
import { BaseComponent } from '../../../common/components/base.component';
import { ConfirmModalComponent } from '../../../common/components/confirm.modal/confirm.modal.component';
import { ConfirmModalActions, ConfirmModalData } from '../../../common/components/confirm.modal/confirm.modal.provider';
import { ModalService } from '../../../common/services/modal.service';
import { ConfigService } from '../../../services/config.service';
import { HubApiService } from '../../../services/hub.api.service';
import { HubFacebookLocationFeedsStore, HubFacebookPageFeedsStore } from '../../../stores/hub.calendar.store';
import { EventLocationAdding } from '../edit.account/event.add.location';
import { EventPageAdding } from '../edit.account/event.add.page';
import { HubComponent } from '../hub.component';
var EventBriteAddComponent = /** @class */ (function (_super) {
    __extends(EventBriteAddComponent, _super);
    function EventBriteAddComponent(router, formBuilder, hubApiService, activatedRoute, modalService, parent, hubFacebookFeedsStore, hubFacebookLocationFeedsStore) {
        var _this = _super.call(this, { activatedRoute: activatedRoute }) || this;
        _this.router = router;
        _this.formBuilder = formBuilder;
        _this.hubApiService = hubApiService;
        _this.activatedRoute = activatedRoute;
        _this.modalService = modalService;
        _this.parent = parent;
        _this.hubFacebookFeedsStore = hubFacebookFeedsStore;
        _this.hubFacebookLocationFeedsStore = hubFacebookLocationFeedsStore;
        _this.eventLocation = new EventLocationAdding();
        _this.eventPage = new EventPageAdding();
        _this.zoom = ConfigService.config.google.fullUSMapZoom;
        _this.isShowMarker = false;
        _this.isFeedExisted = false;
        _this.inAddingLocationFeed = false;
        _this.showSuccessInfo = false;
        _this.mileToMeters = config.mileToMeters;
        return _this;
    }
    EventBriteAddComponent.prototype.ngOnInit = function () {
        var _this = this;
        var hubName = this.allRouteParams.hubName;
        this.hubName = hubName;
        this.eventFormGroup = this.formBuilder.group({
            'facebookPageUrlOrName': [null, [Validators.required]],
            'displayTitle': [null, null],
            'tags': [null, null]
        });
        this.locationFormGroup = this.formBuilder.group({
            'address': [null, [Validators.required]],
            'displayTitle': [null, null],
            'tags': [null, null],
            'radius': [null, [Validators.required]]
        });
        this.hubFacebookFeedsStore.pagesCommand
            .takeUntil(this.isDestroyed)
            .subscribe(function (hubPages) {
            _this.hubPages = hubPages.hubPages ?
                hubPages.hubPages.filter(function (x) { return x.socialName == config.eventbrite; })
                : undefined;
        });
        this.hubFacebookLocationFeedsStore.locationCommand
            .takeUntil(this.isDestroyed)
            .subscribe(function (hubLocations) {
            _this.hubLocations = hubLocations.hubPages ?
                hubLocations.hubPages.filter(function (x) { return x.socialName == config.eventbrite; })
                : undefined;
        });
    };
    EventBriteAddComponent.prototype.addEventBriteOrganizer = function (event) {
        var _this = this;
        var organizer = this.GetOrganizerInfo(this.eventPage.facebookPageUrlOrName);
        if (!organizer) {
            return;
        }
        this.hubApiService.addEventbriteOrganizerFeed(this.hubName, new AddEventBriteGeneralFeedCommand(organizer.organizerID, this.eventPage.displayTitle ? this.eventPage.displayTitle : organizer.name, this.eventPage.tags, this.hubName)).finally(event.complete)
            .subscribe(function (result) {
            var data = {
                confirmModalIcon: 'done',
                confirmModalTitle: 'Success',
                confirmModalDescription: 'Added the events of Eventbrite organizer success',
                confirmModalCancelButtonText: 'OK',
                isAsync: true
            };
            if (result && result.error) {
                data.confirmModalTitle = 'Failed';
                data.confirmModalIcon = 'warning';
                if (result.error.code === 100) {
                    data.confirmModalDescription = 'Uh-oh! Check your Eventbrite organizer settings! ';
                }
                else if (result.error.code === 803) {
                    data.confirmModalDescription = result.error.message.replace('(#803)', 'Uh-oh!');
                }
            }
            else {
                _this.eventFormGroup.markAsPristine();
                _this.eventPage.displayTitle = null;
                _this.eventPage.facebookPageUrlOrName = null;
                _this.hubApiService.getPageFeeds(_this.hubName).subscribe(function (data) {
                    var pageCommand = new HubFacebookFeedsCommand(data);
                    _this.hubFacebookFeedsStore.pagesCommand.next(pageCommand);
                });
            }
            var actions = {};
            _this.modalService.show({
                component: ConfirmModalComponent,
                providers: [
                    { provide: ConfirmModalActions, useValue: actions },
                    { provide: ConfirmModalData, useValue: data }
                ]
            });
        });
    };
    EventBriteAddComponent.prototype.addLocation = function (event) {
        var _this = this;
        this.inAddingLocationFeed = true;
        this.showSuccessInfo = false;
        if (this.isFeedExisted) {
            this.hubApiService.removeLocationFeed(this.hubName, this.eventLocation.feedId, 'eventbrite')
                .finally(function () {
                event.complete();
                _this.inAddingLocationFeed = false;
            }).subscribe(function () {
                _this.locationFormGroup.markAsPristine();
                _this.showSuccessInfo = true;
                setTimeout(function () {
                    _this.showSuccessInfo = false;
                    _this.infoWindow.close();
                    _this.addressInput.clear();
                    _this.getHubLocations();
                }, 1500);
            });
            return;
        }
        // let points = GoogleMapsService.getPoints(this.eventLocation.lat, this.eventLocation.lng, this.eventLocation.radius);
        // console.log(points);
        this.hubApiService.addEventBriteLocationFeed(this.hubName, new AddFacebookLocationFeedCommand(this.eventLocation.address, this.eventLocation.displayTitle ? this.eventLocation.displayTitle : this.autoCompletedAddress.address, this.hubName, null, null, this.eventLocation.lat, this.eventLocation.lng, this.eventLocation.radius, this.eventLocation.tags, config.eventbrite)).finally(function () {
            event.complete();
            _this.inAddingLocationFeed = false;
        }).subscribe(function () {
            _this.locationFormGroup.markAsPristine();
            _this.showSuccessInfo = true;
            _this.getHubLocations();
        });
    };
    EventBriteAddComponent.prototype.getHubLocations = function () {
        var _this = this;
        this.hubApiService.getLocationFeeds(this.hubName).subscribe(function (data) {
            _this.hubLocations = data;
            _this.hubFacebookLocationFeedsStore.locationCommand.next(new HubFacebookFeedsCommand(_this.hubLocations));
        });
    };
    EventBriteAddComponent.prototype.GetOrganizerInfo = function (url) {
        if (!url) {
            return null;
        }
        if (url.startsWith('https://www.eventbrite.com/o/')) {
            var organizer = url.split('?')[0].split('.com/o/')[1].split('/')[0].split('-');
            if (organizer.length > 1) {
                var id = organizer.splice(organizer.length - 1, 1);
                return {
                    organizerID: id[0],
                    name: organizer.join(' ')
                };
            }
        }
        this.modalService.showErrorModal('Please enter a valid eventbrite organizer url!');
        return null;
    };
    EventBriteAddComponent.prototype.findOnMap = function () {
        if (this.autoCompletedAddress) {
            this.showSuccessInfo = false;
            this.eventLocation.lat = this.autoCompletedAddress.lat;
            this.eventLocation.lng = this.autoCompletedAddress.lng;
            this.zoom = ConfigService.config.google.locationMapZoom;
            this.isShowMarker = true;
            this.getLocationStatus();
        }
        else {
            this.resetMap();
        }
    };
    EventBriteAddComponent.prototype.getLocationStatus = function () {
        var _this = this;
        this.hubApiService.getLocationStatus(this.hubName, this.autoCompletedAddress.lat, this.autoCompletedAddress.lng, 'eventbrite')
            .subscribe(function (result) {
            if (result) {
                _this.isFeedExisted = result.connected;
                if (_this.isFeedExisted) {
                    _this.eventLocation.displayTitle = result.title;
                }
                else {
                    _this.eventLocation.displayTitle = _this.autoCompletedAddress.address;
                }
                if (result.radius) {
                    _this.eventLocation.radius = result.radius / config.mileToMeters;
                }
                _this.eventLocation.feedId = result.feedId;
            }
        });
    };
    EventBriteAddComponent.prototype.deleteLocationFeed = function (location) {
        var _this = this;
        var actions = {
            confirm: function (feed) {
                _this.hubApiService.removeLocationFeed(_this.hubName, location.id, 'eventbrite')
                    .finally(feed.complete)
                    .subscribe(function () {
                    _this.getHubLocations();
                });
            }
        };
        var data = {
            confirmModalIcon: 'warning',
            confirmModalTitle: 'Alert',
            confirmModalDescription: 'Are you sure you want to remove this Location?',
            confirmModalConfirmButtonText: 'Remove',
            confirmModalCancelButtonText: 'Cancel',
            isAsync: true
        };
        this.modalService.show({
            component: ConfirmModalComponent,
            providers: [
                { provide: ConfirmModalActions, useValue: actions },
                { provide: ConfirmModalData, useValue: data }
            ]
        });
    };
    EventBriteAddComponent.prototype.deleteEventFeed = function (page) {
        var _this = this;
        var actions = {
            confirm: function (feed) {
                _this.hubApiService.removePageFeed(_this.hubName, page.id)
                    .finally(feed.complete)
                    .subscribe(function () {
                    _this.hubApiService.getPageFeeds(_this.hubName).subscribe(function (data) {
                        var pageCommand = new HubFacebookFeedsCommand(data);
                        _this.hubFacebookFeedsStore.pagesCommand.next(pageCommand);
                    });
                });
            }
        };
        var data = {
            confirmModalIcon: 'warning',
            confirmModalTitle: 'Alert',
            confirmModalDescription: 'Are you sure you want to remove this page?',
            confirmModalConfirmButtonText: 'Remove',
            confirmModalCancelButtonText: 'Cancel',
            isAsync: true
        };
        this.modalService.show({
            component: ConfirmModalComponent,
            providers: [
                { provide: ConfirmModalActions, useValue: actions },
                { provide: ConfirmModalData, useValue: data }
            ]
        });
    };
    EventBriteAddComponent.prototype.resetMap = function () {
        this.eventLocation.lat = ConfigService.config.google.USCenter.lat;
        this.eventLocation.lng = ConfigService.config.google.USCenter.lng;
        this.isShowMarker = false;
        this.zoom = ConfigService.config.google.fullUSMapZoom;
    };
    return EventBriteAddComponent;
}(BaseComponent));
export { EventBriteAddComponent };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/edit.eventbrite/event.brite.add.component.ts.pre-build-optimizer.js